import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';

export default function Login() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    setError('');
    try {
      if (mode === 'login') {
        const params = new URLSearchParams();
        params.append('username', form.email);
        params.append('password', form.password);
        const { data } = await api.post('/auth/login', params);
        localStorage.setItem('token', data.access_token);
      } else {
        const { data } = await api.post('/auth/register', form);
        localStorage.setItem('token', data.access_token);
      }
      navigate('/');
    } catch (e) { setError(e.response?.data?.detail || 'Ошибка'); }
  };

  const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f8f7' }}>
      <div style={{ width: 360, background: '#fff', borderRadius: 12, border: '1px solid #e8e8e6', padding: 32 }}>
        <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 4 }}>🤖 AgentDesk</div>
        <div style={{ color: '#888', fontSize: 14, marginBottom: 24 }}>{mode === 'login' ? 'Войдите в панель' : 'Создайте аккаунт'}</div>
        {mode === 'register' && <input placeholder="Имя" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} />}
        <input placeholder="Email" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inp} />
        <div style={{ position: 'relative', marginBottom: 12 }}>
          <input placeholder="Пароль" type={showPass ? 'text' : 'password'} value={form.password}
            onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && submit()}
            style={{ ...inp, marginBottom: 0, paddingRight: 42 }} />
          <button onClick={() => setShowPass(s => !s)}
            style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#888', padding: 0 }}
            tabIndex={-1}>
            {showPass ? '🙈' : '👁'}
          </button>
        </div>
        {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>{error}</div>}
        <button onClick={submit} style={{ width: '100%', padding: '10px 0', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: 'pointer' }}>
          {mode === 'login' ? 'Войти' : 'Зарегистрироваться'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#888' }}>
          {mode === 'login' ? 'Нет аккаунта? ' : 'Уже есть? '}
          <span onClick={() => setMode(m => m === 'login' ? 'register' : 'login')} style={{ color: '#534AB7', cursor: 'pointer', fontWeight: 500 }}>
            {mode === 'login' ? 'Создать' : 'Войти'}
          </span>
        </div>
      </div>
    </div>
  );
}
